
import React,{useState,useRef} from 'react'
import cn from "classnames";
import OutsideClickHandler from 'react-outside-click-handler';

import Icon from '../../../components/Icon';
import styles from "./Dropdown.module.sass"

const ToteDropdown = ({
  className,
  classDropdownHead,
  options,
  dropdownStyles,
  disabled = false,
}) => {
  const [visible, setVisible] = useState(false);

  const handleClick = (option) => {
    option.onClick();
    setVisible(false);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    if (!disabled) {
      setVisible(!visible);
    }
  };

  const dismissDropdown = () => {
    setVisible(false);
  }


  return (
    <OutsideClickHandler onOutsideClick={() => dismissDropdown()}>
      <div
        className={cn(styles.dropdown, className, { [styles.active]: visible })}
      >
        <div
          className={cn(styles.head, classDropdownHead)}
          style={dropdownStyles}
        >
          <div
            className={cn(styles.arrowWrapper, { [styles.active]: visible })}
            onClick={toggleDropdown}
          >
            <Icon name="menu" size="18" />
          </div>
        </div>
        {visible && !disabled && (
          <div
            className={cn(
              "mt-1 w-fit rounded shadow-lg",
              styles.body,
            )}
          >
            {options.map((option, index) => (
              <div
                className={cn(styles.option, option.className)}
                onClick={() => handleClick(option)}
                key={index}
              >
                {option.icon && (
                  <span className={cn("mr-2", styles.icon)}>{option.icon}</span>
                )}
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default ToteDropdown;